import { InfoCircleOutlined, SmileOutlined } from '@ant-design/icons';
import { Alert, Button, Result, Space, Spin, Statistic } from 'antd';
import { StyledSuccessStep } from './SuccessStep.styled';
import useSuccessStep from './useSuccessStep.hook';
import { Paragraph, Title } from '@/shared/Typography';

export default function SuccessStep({ flowState }) {
  const { state, actions } = useSuccessStep({ flowState });
  return (
    <StyledSuccessStep>
      <Spin spinning={state.loading}>
        <div className="centered-form">
          <Result
            status="success"
            title="You are enrolled now!"
            icon={<SmileOutlined />}
            subTitle={
              <div>
                <Paragraph>
                  Welcome to {flowState.teacherName}'s {flowState.class.name}{' '}
                  class
                </Paragraph>
                {flowState.credentials && (
                  <Alert
                    message={
                      <div className="alert-title">
                        <Paragraph className="big-text">
                          <InfoCircleOutlined className="alert-icon" />
                          <span>
                            Write your username and password in your Spanish
                            folder or keep them in a safe place!
                          </span>
                        </Paragraph>
                      </div>
                    }
                    description={
                      <>
                        <div className="credentials">
                          <div className="cred-item">
                            <div className="label">Username:</div>
                            <div className="value">
                              {flowState.credentials.username}
                            </div>
                          </div>
                          <div className="cred-item">
                            <div className="label">Password:</div>
                            <div className="value">
                              {flowState.credentials.password}
                            </div>
                          </div>
                        </div>
                      </>
                    }
                    type="info"
                  />
                )}
              </div>
            }
            extra={[
              <Button
                type="primary"
                key="continue"
                onClick={actions.goToDashboard}
                size="large"
              >
                Continue
              </Button>,
            ]}
          />
        </div>
      </Spin>
    </StyledSuccessStep>
  );
}
